import { useStore } from '@/hooks/useStore';
import { flowResult } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MileageLimitSetting from './components/MileageLimitSetting';
import DropOffSetting from './components/DropOffSetting';

export default observer(function KilometerLimitPgae() {
    // hook
    const { t } = useTranslation();

    // store
    const {
        systemSettingStore: {
            getMileageLimitAndDropOffSetting
        }
    } = useStore();

    // lifecycle
    useEffect(() => {
        getData();

        return () => {
            // setObservable('', {});
        };
    }, []);

    const getData = async () => {
        await flowResult(getMileageLimitAndDropOffSetting());
    };

    return (
        <div className='flex flex-col gap-10'>
            <MileageLimitSetting />
            <div>
                <h1 className='text-2xl title-page'>{t('words_title.drop_off_title')}</h1>
                <div className='mt-6'>
                    <DropOffSetting />
                </div>
            </div>

        </div>
    );
});
